const Research2Text = (
  <div>
    <h1>Identifying Chemical Impurities:</h1>
    <p className="individualResearchBody">
      A series of fabrication steps are needed to prepare quantum devices. Each
      of these steps can introduce impurities into the constituent materials and
      thereby impact the desired properties. Through the use of techniques such as 
      x-ray photoelectron spectroscopy and secondary ion mass spectrometry, we are
      able to identify the presence of impurities at sensitivities approaching 
      parts-per-billion levels along with their charge states. Moreover, through the
      use of attached <i>in situ</i> processing chambers, we are able to subject 
      specimen to a variety of treatments in ultra-high vacuum conditions and directly
      observe how they impact the chemical configuration of these materials. As such,
      these studies provide insight into the impact fabrication and processing steps
      have on the performance of quantum devices.
    </p>
  </div>
);

const Research2Publication1 = (
  <div>
    <b>Murthy, A. A.</b>; Lee, J.; Kopas, C.; Reagor, M. J.; McFadden, A. P.; Pappas, D. P.;  
    Checchin, M.; Grassellino, A.; Romanenko, A., TOF-SIMS analysis of decoherence sources 
    in superconducting qubits. {" "}
    <i>App. Phys. Lett.</i> 120 (4), <b>2022</b>, 044002 {" "} 
    <a href="https://aip.scitation.org/doi/full/10.1063/5.0079321">[HTML]</a> 
  </div>
);

const Research2Publication2 = (
  <div>
    Oh, J.-S.; Zaman, R.; <b>Murthy, A. A.</b>; Bal, M.; Crisa, F.; Zhu, S.; Torres-Castanedo, C. G.;
     Kopas, C. J.; Mutus, J. Y.; Jing, D.; Zasadzinski, J.; Grassellino, A.; Romanenko, A.; 
     Hersam, M. C.; Bedzyk, M. J.; Kramer, M. J.; Zhou, B.-C.; Zhou, L., 
     Structure and Formation Mechanisms in Tantalum and Niobium Oxides in Superconducting Quantum Circuits. 
     <i>ACS Nano</i>, 18 (30) <b>2024</b>, 19732-19741. 
     <a href="https://pubs.acs.org/doi/10.1021/acsnano.4c05251">[HTML]</a>
  </div>
);

export { Research2Text, Research2Publication1, Research2Publication2 };
